import { GET_DANCE_STYLES_SUCCESS } from '../../../redux/action_types';

const initialState = {
  styles: [],
  categories: [],
  stylesByCategory: [],
};

const danceStylesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DANCE_STYLES_SUCCESS:
      return {
        ...state,
        styles: action.payload,
      };
    default:
      return state;
  }
};

export default danceStylesReducer;
